/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Edit.scss'
import React from 'react'
import r from '../../../util/Renderer'
import Dropdown from '../../atoms/input/Dropdown'
import { Edit } from '../../molecules'
import MoneyInput from '../../unit/MoneyInput'
import MonthlyClosingAction from '../../../action/monthly_closing'
import Money from '../../unit/Money'
import { TextButton, NormalButton, OutlinedButton, CarefulButton } from 'ui-library/dist/external/components'
import ClosingStatus from '../../../domain/model/closing/Status'
import { DatePicker } from '../../atoms'

function EditView(props) {
  const disabled = ClosingStatus.CLOSED === props.head.status

  const ota_sales = props.summary.rsvn_sales ? props.summary.rsvn_sales.ota : []
  const ota_sales_total = props.summary.rsvn_sales ? props.summary.rsvn_sales.total : '-'
  const ota_comsn = props.summary.ota_comsn ? props.summary.ota_comsn.ota : []
  const ota_comsn_total = props.summary.ota_comsn ? props.summary.ota_comsn.total : '-'
  const monthly_close_date = props.head.monthly_close_date ? props.head.monthly_close_date.format('yyyy年MM月') : ''

  const id = props.head.id
  const onRequestSave = id
    ? status => MonthlyClosingAction.onRequestUpdate(id, status, props.head, props.details, props.view.deleted_ids)
    : status => MonthlyClosingAction.onRequestCreate(status, props.head, props.details)

  return (
    <Edit title={'月次締め'} showButton={false} onCancel={MonthlyClosingAction.onCancelEditView}>
      <div className="monthlyProcess">
        <div className="display">
          <div className="displayTarget">
            <span className="targetDate">{monthly_close_date}</span>
            <span className="targetHotel">{props.head.hotel_name}</span>
            <MonthlyClosingStatus>{props.head.status}</MonthlyClosingStatus>
          </div>
        </div>

        <div className="inputs">
          <br />
          <p>
            <strong>運営手数料</strong>
          </p>
          <MoneyInput name="management_comsn" value={props.head.management_comsn} onChange={MonthlyClosingAction.onEdit} disabled={disabled} />円
          <br />
          <div className="actions">{r.renderIf(disabled === false)(<NormalButton onClick={MonthlyClosingAction.addDetail}>+ 項目追加</NormalButton>)}</div>
          <br style={{ clear: 'both' }} />
          <h3>月次データ入力</h3>
          <MonthlyClosingDetails options={props.account_title_detail_options} disabled={disabled}>
            {props.details}
          </MonthlyClosingDetails>
          <br />
          <br />
          <p>
            <strong>メモ</strong>
          </p>
          <textarea name="memo" value={props.head.memo || ''} onChange={MonthlyClosingAction.onEdit} disabled={disabled} />
        </div>

        <br />
        <br />

        <h3>日次サマリー</h3>
        <table className="summary">
          <tbody>
            <tr>
              <th>宿泊料金</th>
              <td>
                <ul>
                  {ota_sales.map(ota => (
                    <li key={ota.site_referrer_id}>{ota.label}</li>
                  ))}
                  <li className="total">合計</li>
                </ul>
              </td>
              <td>
                <ul>
                  {ota_sales.map(ota => (
                    <li key={ota.site_referrer_id}>
                      <Money>{ota.rsvn_sales}</Money>
                    </li>
                  ))}
                  <li className="total">
                    <Money>{ota_sales_total}</Money>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>宿泊料金 決済手数料</th>
              <td>&nbsp;</td>
              <td>
                <ul>
                  <li>
                    <Money>{props.summary.rsvn_pay_comsn}</Money>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>宿泊料金 入金額</th>
              <td>&nbsp;</td>
              <td>
                <ul>
                  <li>
                    <Money>{ota_sales_total - props.summary.rsvn_pay_comsn}</Money>
                  </li>
                </ul>
              </td>
            </tr>

            <tr>
              <th>その他売上</th>
              <td>&nbsp;</td>
              <td>
                <ul>
                  <li>
                    <Money>{props.summary.sales}</Money>
                  </li>
                </ul>
              </td>
            </tr>

            <tr>
              <th>売上原価</th>
              <td>
                <ul>
                  <li>固定費</li>
                  <li>変動費</li>
                  <li className="total">合計</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>
                    <Money>{props.summary.fixed_costs}</Money>
                  </li>
                  <li>
                    <Money>{props.summary.variable_costs}</Money>
                  </li>
                  <li className="total">
                    <Money>{props.summary.fixed_costs + props.summary.variable_costs}</Money>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>販売費及び一般管理費</th>
              <td>
                <ul>
                  <li>固定費</li>
                  <li>変動費</li>
                  <li className="total">合計</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>
                    <Money>{props.summary.fixed_expenses}</Money>
                  </li>
                  <li>
                    <Money>{props.summary.variable_expenses}</Money>
                  </li>
                  <li className="total">
                    <Money>{props.summary.fixed_expenses + props.summary.variable_expenses}</Money>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>OTA手数料</th>
              <td>
                <ul>
                  {ota_comsn.map(ota => (
                    <li key={ota.site_referrer_id}>{ota.label}</li>
                  ))}
                  <li className="total">合計</li>
                </ul>
              </td>
              <td>
                <ul>
                  {ota_comsn.map(ota => (
                    <li key={ota.site_referrer_id}>
                      <Money>{ota.ota_comsn}</Money>
                    </li>
                  ))}
                  <li className="total">
                    <Money>{ota_comsn_total}</Money>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>宿泊税</th>
              <td>&nbsp;</td>
              <td>
                <ul>
                  <li>
                    <Money>{props.summary.accom_tax}</Money>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>宿泊税 決済手数料</th>
              <td>&nbsp;</td>
              <td>
                <ul>
                  <li>
                    <Money>{props.summary.accom_pay_comsn}</Money>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>宿泊税 入金額</th>
              <td>&nbsp;</td>
              <td>
                <ul>
                  <li>
                    <Money>{props.summary.accom_tax - props.summary.accom_pay_comsn}</Money>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>

        <br />

        <div className="actions">
          {r.renderIfOrElse(props.head.status === ClosingStatus.CLOSED)(<CarefulButton onClick={e => onRequestSave(ClosingStatus.SAVED)}>月次締め解除</CarefulButton>)(
            <React.Fragment>
              <OutlinedButton onClick={e => onRequestSave(ClosingStatus.CLOSED)}>月次締め</OutlinedButton>
              <TextButton onClick={e => onRequestSave(ClosingStatus.SAVED)}>保存</TextButton>
            </React.Fragment>
          )}
          <br style={{ clear: 'both' }} />
        </div>
      </div>
    </Edit>
  )
}

function MonthlyClosingDetails(props) {
  const details = props.children
  if (details.length === 0) return null

  return (
    <table>
      <colgroup>
        <col width="32%" />
        <col width="23%" />
        <col width="20%" />
        <col width="23%" />
        <col width="3%" />
      </colgroup>
      <tbody>
        {details.map((row, index) => (
          <DetailInputRow key={index} index={index} options={props.options} disabled={props.disabled}>
            {row}
          </DetailInputRow>
        ))}
      </tbody>
    </table>
  )
}

function MonthlyClosingStatus(props) {
  const status = props.children || ClosingStatus.NONE
  return <span className={`status status--${status}`}>{ClosingStatus.getLabel(status)}</span>
}

function DetailInputRow(props) {
  const index = props.index
  const item = props.children
  const disabled = props.disabled

  function onChange(e) {
    MonthlyClosingAction.onEditDetail(e, index)
  }

  return (
    <tr>
      <td>
        <Dropdown
          name="account_title_detail_id"
          options={props.options}
          value={item.account_title_detail_id}
          onChange={onChange}
          placeholder="選択"
          searchable={true}
          isMulti={false}
          disabled={disabled}
        />
      </td>
      <td>
        <MoneyInput name="price" value={item.price} onChange={onChange} disabled={disabled} />円
      </td>
      <td>
        <DatePicker
          name="occurred_on"
          selected={item.occurred_on}
          value={item.occurred_on}
          onChange={onChange}
          showTimeSelect={false}
          isClearable={true}
          placeholderText="発生日"
          disabled={disabled}
        />
      </td>
      <td>
        <input type="input" name="remarks" value={item.remarks || ''} placeholder="備考" onChange={onChange} style={{ height: '38px', marginLeft: '6px' }} disabled={disabled} />
      </td>
      <td>
        {r.renderIf(disabled === false)(
          <a className="closeButton" href="#" onClick={e => MonthlyClosingAction.onDeleteDetail(e, index, item.id)}>
            &nbsp;×&nbsp;
          </a>
        )}
      </td>
    </tr>
  )
}

export default EditView
